/**
 * Created by hernanherreros on 2019-06-27
 */

import * as React from 'react'
import styled from 'styled-components'
import LoaderWrapper from '../../../components/Utils/LoaderWrapper'
import { message, Icon } from 'antd'
import { checkActivityAvailability, getActivitiy, getActivitySpeakers, getSubActivities } from '../requests/activities'
import Button from '../../../components/Utils/Button'
import { Trans } from '@lingui/macro'
import ActivitiesContext from './ActivitiesContext'
import ActivityDetailModal from './ActivityDetailModal'
import { Alert } from 'antd'


interface Props {
  id: number;
  isInscribable: boolean;
}

interface State {
  isAvailable: boolean;
  isLoading: boolean;
  data: any;
  subActivities: any[];
  speakers: any[];
  isDetailOpen: boolean;
}

export default class ActivityCard extends React.Component<Props, State> {
  static contextType = ActivitiesContext

  static defaultProps = {
    isInscribable: true
  }

  state: State = {
    isAvailable: true,
    isLoading: true,
    data: {},
    subActivities: [],
    speakers: [],
    isDetailOpen: false,
  }

  interval: any = null

  componentDidMount () {
    const { id } = this.props
    const { setActivityAvailability } = this.context

    setActivityAvailability(id, true)

    this.loadData()

    this.interval = setInterval(this.checkAvailability, 2000)
  }

  componentWillUnmount () {
    clearInterval(this.interval)
  }

  loadData = async () => {
    const { id } = this.props
    const { setActivityAvailability } = this.context

    this.setState({ isLoading: true })

    try {
      const activity = await getActivitiy({ id })
      const subActivities = await getSubActivities({ activityId: id })
      const activitySpeakers = await getActivitySpeakers({ activityId: id })
      const availability = await checkActivityAvailability({ id, timestamp: new Date().getTime() })

      setActivityAvailability(id, availability.Data.IsAvailable)

      const speakers = activitySpeakers.Data.map((ap: any) => ap.Included.Speaker)

      console.log('speakers', speakers)

      this.setState({ data: activity.Data, subActivities: subActivities.Data, speakers })
    } catch (e) {
      message.error(e.message)
    } finally {
      this.setState({ isLoading: false })
    }
  }

  checkAvailability = async () => {
    const { id } = this.props
    const { setActivityAvailability } = this.context

    try {
      const availability = await checkActivityAvailability({ id, timestamp: new Date().getTime() })

      setActivityAvailability(id, availability.Data.IsAvailable)
    } finally {
    }
  }

  isActivitySelected = () => {
    const { id } = this.props
    const { selectedActivities } = this.context

    const index = selectedActivities.indexOf(id)

    return index > - 1
  }

  getActivity = () => {
    const { id } = this.props
    const { activities } = this.context

    return activities.find((a: any) => a.ID === id) || {}
  }

  render() {
    const { isLoading } = this.state
    const { isInscribable } = this.props

    const activity = this.getActivity()

    if (Object.keys(activity).length === 0) {
      return null
    }

    const startHour = new Date(activity.StartsAt).toLocaleTimeString('es-CL').substring(0, 5)
    const endHour = new Date(activity.EndsAt).toLocaleTimeString('es-CL').substring(0, 5)

    return (
      <React.Fragment>
        <Card>
          <LoaderWrapper size="default" isLoading={isLoading}>
            <CardContent>
              <span>{startHour} a {endHour}</span><br/>
              <span>{activity.Location}</span>
              <h4>{activity.Name}</h4>
              <ProgramButton onClick={() => this.setState({ isDetailOpen: true })}><Trans>Ver detalle</Trans></ProgramButton>

              {!isInscribable && <CustomAlert message="Esta actividad no permite inscripciones. Si la eliminas de tu selección no podrás volver a inscribirla." type="warning" />}
            </CardContent>
            {this.renderCardButton()}
          </LoaderWrapper>
        </Card>
        {this.renderDetailModal()}
      </React.Fragment>
    )
  }

  renderCardButton () {
    return (
      <CardButton>
        {this.renderInscriptionButton(false,true)}
      </CardButton>
    )
  }

  renderInscriptionButton = (slim = true, squared = false, inline = false, onClickCallback?: any) => {
    const { id } = this.props
    const { selectActivity, removeActivity } = this.context

    const activity = this.getActivity()
    const selected = this.isActivitySelected()

    const onClick = selected ? removeActivity : selectActivity
    const buttonColor = selected ? '#F46B75' : '#5A87CD'

    const buttonIcon = selected ? 'close-circle' : 'calendar'
    const buttonLabel = selected ? <Trans>Desinscribir</Trans> : <Trans>Inscribir</Trans>

    const notAvailableIcon = 'lock'
    const notAvailableLabel = <Trans>Sin cupos</Trans>
    const notAvailableColor = '#ababab'

    const isAvailable = activity.IsAvailable || activity.FromUserSelection

    const handleClick = () => {
      onClick(id)
      onClickCallback && onClickCallback()
    }

    const finalColor = isAvailable ? buttonColor : notAvailableColor
    return (
      <Button onClick={handleClick} color={finalColor} slim={slim} squared={squared} inline={inline} disabled={!isAvailable}>
        <IconWrapper>
          <Icon type={isAvailable ? buttonIcon : notAvailableIcon}/>
        </IconWrapper>
        {isAvailable ? buttonLabel : notAvailableLabel}
      </Button>
    )
  }

  renderDetailModal = () => {
    const { isDetailOpen, data, subActivities, speakers } = this.state

    return (
      <ActivityDetailModal
        speakers={speakers}
        isOpen={isDetailOpen}
        data={data}
        subActivities={subActivities}
        onClose={() => this.setState({ isDetailOpen: false })}
        customRender={() => this.renderInscriptionButton(true, false, true)}
      />
    )
  }
}

// Card styles

const Card = styled.div`
  box-shadow: 0px 4px 11px 2px rgb(228, 233, 239);
  border-radius: 10px;
  margin: 16px 0;
  min-height: 180px;
  transition: all .2s ease-in-out;
  overflow: hidden;

  > div {
    display: flex;
    flex-direction: column;
    min-height: 180px;
  }

  &:hover {
   box-shadow: 0 15px 12px 2px rgb(228, 233, 239);
   transform: translateY(-5px) scale(1.01);
  }
`

const CardContent = styled.div`
  flex: 1;
  padding: 10px;
  background-color: #fdfdfe;
`

const CardButton = styled.div`
  button {
    padding: 12px 32px;
    width: 100%;
  }
`

const IconWrapper = styled.span`
  padding-right: 5px;
`

const ProgramButton = styled.button`
  background: none;
  padding: 0;
  border: none;
  color: #5A87CD;
  cursor: pointer;
  outline: none;
`

const CustomAlert = styled(Alert)`
  margin-top: 10px !important;

  * {
    font-size: 12px !important;
  }
`
